/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const getActivityPathParamsSchema = z.object({
  id: z.coerce.number().int(),
});

/**
 * @description OK
 */
export const getActivity200Schema = z.object({
  id: z.coerce.number().int(),
  customerId: z.coerce.number().int(),
  customerName: z.coerce.string(),
  description: z.coerce.string().nullable(),
  projectId: z.coerce.number().int().nullable(),
  projectName: z.coerce.string().nullable(),
  fromTime: z.string().datetime({ local: true }),
  toTime: z.string().datetime({ local: true }),
  effectiveHours: z.coerce.number(),
  km: z.coerce.number().nullable(),
  extraCosts: z.coerce.number().nullable(),
  costsDescription: z.coerce.string().nullable(),
  employeeId: z.coerce.number().int(),
  employeeName: z.coerce.string(),
  documents: z.array(
    z.object({
      id: z.coerce.number().int(),
      fileName: z.coerce.string(),
      description: z.coerce.string().nullable().nullish(),
      contentType: z.coerce.string(),
      fileExtension: z.coerce.string(),
      fileSizeBytes: z.coerce.number().int(),
      uploadedAt: z.string().datetime({ local: true }),
      updatedAt: z.string().datetime({ local: true }),
      uploadedByUserId: z.coerce.number().int().nullable().nullish(),
      linkedStatiniCount: z.coerce.number().int(),
    }),
  ),
});

export const getActivityQueryResponseSchema = z.lazy(
  () => getActivity200Schema,
);
